import '../../scss/parts/forecastPageTemplate.scss';
import '../../scss/parts/datepicker.scss';
import forecastDatePicker from "../widgets/foreastDatePicker.js";
import priceChart from "../widgets/priceChart.js";

(async function ($) {
    $(async function () {
        priceChart.init();
        priceChart.drawChart('chartWeekAhead');
        priceChart.drawChart('chartYearAhead');
        await forecastDatePicker.init();
    });
}(jQuery));